import { render } from "./wrongQuestionList.vue?vue&type=template&id=7461aedf&scoped=true"
import script from "./wrongQuestionList.vue?vue&type=script&lang=js"
export * from "./wrongQuestionList.vue?vue&type=script&lang=js"

import "./wrongQuestionList.vue?vue&type=style&index=0&id=7461aedf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7461aedf"]])

export default __exports__